export function getLocale(cb?: (locale: string | null) => void): void | string {
  let locale: string;

  if (typeof window === 'undefined') {
    if (cb) {
      cb(null);
    }

    return '';
  }

  if (window.navigator && window.navigator.language) {
    locale = window.navigator.language.split('-')[0];
  } else {
    locale = 'en';
  }

  if (!cb) {
    return locale;
  }

  return cb(locale);
}

export function navigateObject(
  path: string,
  object: Record<string, any> = {}
): any {
  try {
    return path.split('.').reduce((o, i) => o[i], object);
  } catch (err) {
    console.error(err);
    return path;
  }
}

export function replaceArgs(
  str: string = '',
  args?: Record<string, any>
): string {
  if (!args) {
    return str;
  }

  return Object.keys(args).reduce((acc, arg) => {
    return acc.replace(new RegExp(`#{${arg}}`, 'g'), args[arg]);
  }, str);
}

export function createTranslator(
  lang: string = 'en',
  defaultTranslations: Record<string, any> = {},
  customTranslations: Record<string, any> = {}
): any {
  let translations: Record<string, any>;

  if (customTranslations && customTranslations[lang]) {
    translations = {
      ...defaultTranslations[lang],
      ...customTranslations[lang]
    };
  } else {
    translations = defaultTranslations[lang] || defaultTranslations['en'] || {};
  }

  return (path: string, args?: Record<string, any>) => {
    const translation = navigateObject(path, translations);
    return replaceArgs(translation, args);
  };
}
